import React from "react";
import { Link } from "react-router-dom";
import EmployeeMatchIndustrySection from "../../components/employee/EmployeeMatchIndustrySection";
import EmployeeFAQSection from "../../components/employee/EmployeeFAQSection";

const EmployeeLandingPage = () => {
    return (
        <>
        <style>{`
            @media (max-width: 768px) {
                .employee-landing-hero {
                    padding-top: 1rem !important;
                }
                .employee-cards-section {
                    margin-top: -3rem !important;
                }
                .employee-how-it-works-section {
                    margin-top: -5rem !important;
                }
                .employee-heading-h1 {
                    font-size: 24px !important;
                }
                .employee-heading-h2 {
                    font-size: 26px !important;
                }
                .employee-heading-h3 {
                    font-size: 24px !important;
                }
                .employee-card-heading {
                    font-size: 24px !important;
                }
                .employee-create-profile-section {
                    margin-top: 2rem !important;
                }
                .employee-get-approved-section {
                    margin-top: 2rem !important;
                }
                .employee-accelerate-section {
                    margin-top: 2rem !important;
                }
            }
        `}</style>
        <main
            className="bg-[#f2f6ff] min-h-screen font-sans"
            style={{ fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' }}
        >
            <section className="max-w-6xl mx-auto px-6 pt-20 pb-24 employee-landing-hero">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="space-y-6">
                        <span className="inline-flex items-center px-5 py-2 rounded-full bg-[#d9f2df] text-[#11452c] text-sm font-semibold w-max">
                            Find a role
                        </span>
                        <div className="space-y-4">
                            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-normal text-gray-900 leading-tight employee-heading-h1">
                                It's your career.
                                <br />
                                Let's make it work
                            </h1>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                Doctors' Jobs is a job platform built exclusively for doctors and designed to
                                help you find opportunities both within clinical practice and beyond. We connect
                                you to employers and career pathways that fit your goals, so you can focus on
                                what you do best: helping patients and growing your expertise.
                            </p>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-4 pt-4">
                            <Link
                                to="/signup"
                                className="inline-flex items-center justify-center rounded-full px-8 py-3 bg-black text-white text-base font-semibold hover:bg-gray-900 transition-colors"
                            >
                                Get matched to jobs
                            </Link>
                        </div>
                    </div>
                    <div className="relative flex justify-center lg:justify-end">
                        <div className="w-full max-w-lg lg:max-w-xl rounded-[36px] overflow-hidden shadow-[0_25px_80px_rgba(32,56,117,0.18)] translate-x-2 sm:translate-x-4 lg:translate-x-8">
                            <img
                                src="/Find a doctors’ job_ header image.webp"
                                alt="Doctor reviewing a patient file"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-[#f2f6ff] employee-cards-section">
                <div className="max-w-7xl mx-auto px-6 py-16">
                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                title: "Get matches",
                                description:
                                    "We connect you to jobs that align with your skills, experience, and career interests. Helping you save you time and surfacing the right opportunities faster.",
                                icon: "/Get instant matches.svg",
                            },
                            {
                                title: "Take ownership",
                                description:
                                    "Your profile, your data, your growth. You're in control of your career journey with no middlemen or hidden fees.",
                                icon: "/Take ownership.svg",
                            },
                            {
                                title: "Earn more, stress less",
                                description:
                                    "No membership costs. No talent fees. Keep 100% of what you earn and get transparent insights into your job offers.",
                                icon: "/Earn more, stress less.svg",
                            },
                        ].map((card, index) => (
                            <div
                                key={card.title}
                                className="bg-gray-50 rounded-[32px] p-8 shadow-sm border border-gray-100"
                            >
                                <div className="text-gray-800 mb-4">
                                    <img src={card.icon} alt={card.title} className="w-8 h-8" />
                                </div>
                                <h3 className="text-xl font-bold text-gray-900 mb-3 employee-card-heading">
                                    {card.title}
                                </h3>
                                <p className="text-base text-gray-700 leading-relaxed">
                                    {card.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="bg-[#f2f6ff] employee-how-it-works-section">
                <div className="max-w-6xl mx-auto px-6 py-20 space-y-32">
                    <div className="text-center">
                        <h2 className="text-4xl sm:text-5xl font-normal text-gray-900 employee-heading-h2">Here's how it works</h2>
                    </div>
                    <div className="grid lg:grid-cols-2 gap-12 items-center employee-create-profile-section">
                        <div className="space-y-6">
                            <div className="w-12 h-12 border-2 border-gray-900 rounded-full flex items-center justify-center text-xl font-medium text-gray-900">
                                1
                            </div>
                            <div className="space-y-4">
                                <h3 className="text-4xl font-normal leading-tight text-gray-900 employee-heading-h3">
                                    Create your
                                    <br />
                                    Doctors' Jobs profile
                                </h3>
                                <p className="text-xl text-gray-700 leading-relaxed">
                                    Add your qualifications, clinical experience, and certifications so employers immediately see your strengths. Keep everything updated in one place.
                                </p>
                            </div>
                            <Link
                                to="/signup"
                                className="inline-flex items-center justify-center rounded-full px-8 py-3 bg-black text-white text-base font-semibold hover:bg-gray-900 transition-colors w-max"
                            >
                                Get matched to jobs
                            </Link>
                        </div>
                        <div className="flex justify-center lg:justify-end">
                            <img
                                src="/Create your  Doctors’ Jobs profile.png"
                                alt="Create your Doctors' Jobs profile preview"
                                className="w-full max-w-xl rounded-[40px]"
                            />
                        </div>
                    </div>
                    <div className="grid lg:grid-cols-2 gap-12 items-center employee-get-approved-section">
                        <div className="flex justify-center lg:justify-start order-last lg:order-first">
                            <img
                                src="/Get approved.png"
                                alt="Doctor approval illustration"
                                className="w-full max-w-xl rounded-[32px]"
                            />
                        </div>
                        <div className="space-y-6 order-first lg:order-last">
                            <div className="w-12 h-12 border-2 border-gray-900 rounded-full flex items-center justify-center text-xl font-medium text-gray-900">
                                2
                            </div>
                            <div className="space-y-4">
                                <h3 className="text-4xl font-normal leading-tight text-gray-900 employee-heading-h3">
                                    Get approved
                                </h3>
                                <p className="text-xl text-gray-700 leading-relaxed">
                                    Within a few days, we’ll verify your medical registration number and award you an <span className="font-semibold">Approved Talent Badge</span>, confirming your credentials as a medical professional.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="grid lg:grid-cols-2 gap-12 items-center employee-accelerate-section">
                        <div className="space-y-6">
                            <div className="w-12 h-12 border-2 border-gray-900 rounded-full flex items-center justify-center text-xl font-medium text-gray-900">
                                3
                            </div>
                            <div className="space-y-4">
                                <h3 className="text-4xl font-normal leading-tight text-gray-900 employee-heading-h3">
                                    Accelerate your career
                                </h3>
                                <p className="text-xl text-gray-700 leading-relaxed">
                                    Once approved, we match you with top jobs that align with your skills, experience, and role interests. Apply directly, interview with confidence, and start your next chapter.
                                </p>
                            </div>
                        </div>
                        <div className="flex justify-center lg:justify-end">
                            <img
                                src="/Accelerate your career updated.webp"
                                alt="Accelerate your career illustration"
                                className="w-full max-w-xl rounded-[40px]"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <EmployeeMatchIndustrySection />
        <EmployeeFAQSection />
        </>
    );
};

export default EmployeeLandingPage;

